import type { Anime } from '@/mocks/anime';

interface AnimeCardProps {
  anime: Anime;
}

export default function AnimeCard({ anime }: AnimeCardProps) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-2xl bg-background-100/80 transition duration-300 hover:-translate-y-1">
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={anime.image}
          alt={`${anime.title} 治愈系动画封面`}
          title={`${anime.title} 补番推荐`}
          className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
        />
        <div className="absolute left-3 top-3 rounded-full bg-foreground-950/60 px-3 py-1 text-xs font-medium text-background-50 backdrop-blur">
          {anime.year}
        </div>
        <div className="absolute bottom-3 right-3 flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-1 text-sm font-bold text-primary-700">
          <i className="ri-star-fill text-xs text-primary-500"></i>
          {anime.rating.toFixed(1)}
        </div>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-4">
        <h3 className="text-base font-semibold leading-snug text-foreground-950">{anime.title}</h3>
        <div className="flex flex-wrap gap-1.5">
          {anime.tags.map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>
        <p className="line-clamp-3 text-sm leading-relaxed text-foreground-600">
          {anime.synopsis}
        </p>
        <div className="mt-auto flex items-center justify-between pt-2 text-xs text-foreground-500">
          <span>{anime.episodes}</span>
          <span className="text-foreground-400">{anime.status}</span>
        </div>
      </div>
    </article>
  );
}